import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\cssToolbarButtonLike.ts.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\cssToolbarButtonLike.ts.esbuild-plugin-windicss.css';
import { css } from '@linaria/core';
export const cssToolbarButtonLike = "c1b1xloi";